// Generated by scripts/write-indian-poker-replay-fixtures.ts.
// Do not edit manually.

import type { IndianPokerViewerState } from "@cloudnest/indian-poker-engine";
import type { IndianPokerReplayEventType } from "./event-adapter";

export interface IndianPokerReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface IndianPokerReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: IndianPokerReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
  readonly viewerState: IndianPokerViewerState;
}

export interface IndianPokerReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "indian-poker";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly observerUserId: string;
  readonly players: readonly IndianPokerReplayFixturePlayer[];
  readonly events: readonly IndianPokerReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const INDIAN_POKER_REPLAY_FIXTURES: Record<
  string,
  IndianPokerReplayFixture
> = {
  "simple-2p-raise-call": {
    schemaVersion: 1,
    gameType: "indian-poker",
    scenario: "simple-2p-raise-call",
    source: "generated",
    capturedAt: "2026-06-09T00:00:00.000Z",
    observerUserId: "observer",
    players: [
      {
        id: "p1",
        name: "Red",
        role: "host",
      },
      {
        id: "p2",
        name: "Blue",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          actionId: "simple-2p-raise-call:server-init",
        },
        viewerState: {
          gameId: "indian-poker-replay-simple-2p-raise-call",
          status: "IN_PROGRESS",
          hostPlayerId: "p1",
          players: [
            {
              playerId: "p1",
              chips: 19,
              currentBet: 1,
            },
            {
              playerId: "p2",
              chips: 19,
              currentBet: 1,
            },
          ],
          round: {
            roundNumber: 1,
            phase: "BETTING",
            activePlayerId: "p2",
            bettingPriorityPlayerId: "p2",
            pot: 2,
            carryoverPot: 0,
            actedPlayerIds: [],
            cards: [
              {
                playerId: "p1",
                card: null,
                hidden: true,
              },
              {
                playerId: "p2",
                card: null,
                hidden: true,
              },
            ],
            confirmedPlayerIds: [],
          },
          completedRounds: [],
          deckGeneration: 1,
          initialPriorityDraws: [],
        },
      },
      {
        sequenceNumber: 2,
        eventType: "SyncViewerState",
        userId: "p1",
        payload: {
          actionId: "simple-2p-raise-call:sync-initial-view",
        },
        viewerState: {
          gameId: "indian-poker-replay-simple-2p-raise-call",
          status: "IN_PROGRESS",
          hostPlayerId: "p1",
          players: [
            {
              playerId: "p1",
              chips: 19,
              currentBet: 1,
            },
            {
              playerId: "p2",
              chips: 19,
              currentBet: 1,
            },
          ],
          round: {
            roundNumber: 1,
            phase: "BETTING",
            activePlayerId: "p2",
            bettingPriorityPlayerId: "p2",
            pot: 2,
            carryoverPot: 0,
            actedPlayerIds: [],
            cards: [
              {
                playerId: "p1",
                card: null,
                hidden: true,
              },
              {
                playerId: "p2",
                card: null,
                hidden: true,
              },
            ],
            confirmedPlayerIds: [],
          },
          completedRounds: [],
          deckGeneration: 1,
          initialPriorityDraws: [],
        },
      },
      {
        sequenceNumber: 3,
        eventType: "RAISE",
        userId: "p2",
        payload: {
          actionId: "simple-2p-raise-call:3:RAISE",
          totalBet: 4,
        },
        viewerState: {
          gameId: "indian-poker-replay-simple-2p-raise-call",
          status: "IN_PROGRESS",
          hostPlayerId: "p1",
          players: [
            {
              playerId: "p1",
              chips: 19,
              currentBet: 1,
            },
            {
              playerId: "p2",
              chips: 16,
              currentBet: 4,
            },
          ],
          round: {
            roundNumber: 1,
            phase: "BETTING",
            activePlayerId: "p1",
            bettingPriorityPlayerId: "p2",
            pot: 5,
            carryoverPot: 0,
            actedPlayerIds: ["p2"],
            cards: [
              {
                playerId: "p1",
                card: null,
                hidden: true,
              },
              {
                playerId: "p2",
                card: null,
                hidden: true,
              },
            ],
            confirmedPlayerIds: [],
          },
          completedRounds: [],
          deckGeneration: 1,
          initialPriorityDraws: [],
        },
      },
      {
        sequenceNumber: 4,
        eventType: "CALL",
        userId: "p1",
        payload: {
          actionId: "simple-2p-raise-call:4:CALL",
        },
        viewerState: {
          gameId: "indian-poker-replay-simple-2p-raise-call",
          status: "IN_PROGRESS",
          hostPlayerId: "p1",
          players: [
            {
              playerId: "p1",
              chips: 16,
              currentBet: 4,
            },
            {
              playerId: "p2",
              chips: 24,
              currentBet: 4,
            },
          ],
          round: {
            roundNumber: 1,
            phase: "ROUND_RESULT",
            activePlayerId: "p1",
            bettingPriorityPlayerId: "p2",
            pot: 8,
            carryoverPot: 0,
            actedPlayerIds: ["p2", "p1"],
            cards: [
              {
                playerId: "p1",
                card: {
                  id: "g1-v3-c2",
                  value: 3,
                },
                hidden: false,
              },
              {
                playerId: "p2",
                card: {
                  id: "g1-v10-c1",
                  value: 10,
                },
                hidden: false,
              },
            ],
            winnerPlayerId: "p2",
            resultReason: "HIGH_CARD",
            confirmedPlayerIds: [],
          },
          completedRounds: [],
          deckGeneration: 1,
          initialPriorityDraws: [],
        },
      },
      {
        sequenceNumber: 5,
        eventType: "CONFIRM_ROUND_RESULT",
        userId: "p1",
        payload: {
          actionId: "simple-2p-raise-call:5:CONFIRM_ROUND_RESULT",
        },
        viewerState: {
          gameId: "indian-poker-replay-simple-2p-raise-call",
          status: "IN_PROGRESS",
          hostPlayerId: "p1",
          players: [
            {
              playerId: "p1",
              chips: 16,
              currentBet: 4,
            },
            {
              playerId: "p2",
              chips: 24,
              currentBet: 4,
            },
          ],
          round: {
            roundNumber: 1,
            phase: "ROUND_RESULT",
            activePlayerId: "p1",
            bettingPriorityPlayerId: "p2",
            pot: 8,
            carryoverPot: 0,
            actedPlayerIds: ["p2", "p1"],
            cards: [
              {
                playerId: "p1",
                card: {
                  id: "g1-v3-c2",
                  value: 3,
                },
                hidden: false,
              },
              {
                playerId: "p2",
                card: {
                  id: "g1-v10-c1",
                  value: 10,
                },
                hidden: false,
              },
            ],
            winnerPlayerId: "p2",
            resultReason: "HIGH_CARD",
            confirmedPlayerIds: ["p1"],
          },
          completedRounds: [],
          deckGeneration: 1,
          initialPriorityDraws: [],
        },
      },
      {
        sequenceNumber: 6,
        eventType: "CONFIRM_ROUND_RESULT",
        userId: "p2",
        payload: {
          actionId: "simple-2p-raise-call:6:CONFIRM_ROUND_RESULT",
        },
        viewerState: {
          gameId: "indian-poker-replay-simple-2p-raise-call",
          status: "IN_PROGRESS",
          hostPlayerId: "p1",
          players: [
            {
              playerId: "p1",
              chips: 15,
              currentBet: 1,
            },
            {
              playerId: "p2",
              chips: 23,
              currentBet: 1,
            },
          ],
          round: {
            roundNumber: 2,
            phase: "BETTING",
            activePlayerId: "p2",
            bettingPriorityPlayerId: "p2",
            pot: 2,
            carryoverPot: 0,
            actedPlayerIds: [],
            cards: [
              {
                playerId: "p1",
                card: null,
                hidden: true,
              },
              {
                playerId: "p2",
                card: null,
                hidden: true,
              },
            ],
            confirmedPlayerIds: [],
          },
          completedRounds: [
            {
              roundNumber: 1,
              phase: "ROUND_RESULT",
              activePlayerId: "p1",
              bettingPriorityPlayerId: "p2",
              pot: 8,
              carryoverPot: 0,
              actedPlayerIds: ["p2", "p1"],
              cardsByPlayerId: {
                p1: {
                  id: "g1-v3-c2",
                  value: 3,
                },
                p2: {
                  id: "g1-v10-c1",
                  value: 10,
                },
              },
              confirmedPlayerIds: ["p1", "p2"],
              winnerPlayerId: "p2",
              resultReason: "HIGH_CARD",
            },
          ],
          deckGeneration: 1,
          initialPriorityDraws: [],
        },
      },
      {
        sequenceNumber: 7,
        eventType: "RAISE",
        userId: "p2",
        payload: {
          actionId: "simple-2p-raise-call:7:RAISE",
          totalBet: 3,
        },
        viewerState: {
          gameId: "indian-poker-replay-simple-2p-raise-call",
          status: "IN_PROGRESS",
          hostPlayerId: "p1",
          players: [
            {
              playerId: "p1",
              chips: 15,
              currentBet: 1,
            },
            {
              playerId: "p2",
              chips: 21,
              currentBet: 3,
            },
          ],
          round: {
            roundNumber: 2,
            phase: "BETTING",
            activePlayerId: "p1",
            bettingPriorityPlayerId: "p2",
            pot: 4,
            carryoverPot: 0,
            actedPlayerIds: ["p2"],
            cards: [
              {
                playerId: "p1",
                card: null,
                hidden: true,
              },
              {
                playerId: "p2",
                card: null,
                hidden: true,
              },
            ],
            confirmedPlayerIds: [],
          },
          completedRounds: [
            {
              roundNumber: 1,
              phase: "ROUND_RESULT",
              activePlayerId: "p1",
              bettingPriorityPlayerId: "p2",
              pot: 8,
              carryoverPot: 0,
              actedPlayerIds: ["p2", "p1"],
              cardsByPlayerId: {
                p1: {
                  id: "g1-v3-c2",
                  value: 3,
                },
                p2: {
                  id: "g1-v10-c1",
                  value: 10,
                },
              },
              confirmedPlayerIds: ["p1", "p2"],
              winnerPlayerId: "p2",
              resultReason: "HIGH_CARD",
            },
          ],
          deckGeneration: 1,
          initialPriorityDraws: [],
        },
      },
      {
        sequenceNumber: 8,
        eventType: "FOLD",
        userId: "p1",
        payload: {
          actionId: "simple-2p-raise-call:8:FOLD",
        },
        viewerState: {
          gameId: "indian-poker-replay-simple-2p-raise-call",
          status: "IN_PROGRESS",
          hostPlayerId: "p1",
          players: [
            {
              playerId: "p1",
              chips: 15,
              currentBet: 1,
            },
            {
              playerId: "p2",
              chips: 25,
              currentBet: 3,
            },
          ],
          round: {
            roundNumber: 2,
            phase: "ROUND_RESULT",
            activePlayerId: "p1",
            bettingPriorityPlayerId: "p2",
            pot: 4,
            carryoverPot: 0,
            actedPlayerIds: ["p2"],
            cards: [
              {
                playerId: "p1",
                card: {
                  id: "g1-v3-c1",
                  value: 3,
                },
                hidden: false,
              },
              {
                playerId: "p2",
                card: {
                  id: "g1-v1-c1",
                  value: 1,
                },
                hidden: false,
              },
            ],
            winnerPlayerId: "p2",
            foldedPlayerId: "p1",
            resultReason: "FOLD",
            confirmedPlayerIds: [],
          },
          completedRounds: [
            {
              roundNumber: 1,
              phase: "ROUND_RESULT",
              activePlayerId: "p1",
              bettingPriorityPlayerId: "p2",
              pot: 8,
              carryoverPot: 0,
              actedPlayerIds: ["p2", "p1"],
              cardsByPlayerId: {
                p1: {
                  id: "g1-v3-c2",
                  value: 3,
                },
                p2: {
                  id: "g1-v10-c1",
                  value: 10,
                },
              },
              confirmedPlayerIds: ["p1", "p2"],
              winnerPlayerId: "p2",
              resultReason: "HIGH_CARD",
            },
          ],
          deckGeneration: 1,
          initialPriorityDraws: [],
        },
      },
    ],
    notes: [
      "Indian Poker replay fixtures store rule-service-style redacted event payloads plus observer viewer-state snapshots.",
      "The app fixture intentionally omits canonical init state, deck, RNG state, seed, and current betting cards.",
      "The scenario covers raise/call, round confirmation, and a second-round fold for L3 review.",
    ],
  },
};
